/** @file Node name to PoseBuffer index (`Object.keys(puppet.nodes)` order), memoised per puppet (R4). */
import type { Puppet } from '@zilo/pose3d-format/types/puppet';

const cache = new WeakMap<Puppet['nodes'], Map<string, number>>();

/** The buffer index of every node; the same map for the same `puppet.nodes` object. */
export function nodeIndexOf(puppet: Puppet): Map<string, number> {
  const hit = cache.get(puppet.nodes);
  if (hit !== undefined) return hit;
  const map = new Map(Object.keys(puppet.nodes).map((name, i) => [name, i] as const));
  cache.set(puppet.nodes, map);
  return map;
}
